<template>

<div>
    <h3 class="fieldset-title mt-5 mb-2">
        Изисквания за етапа:
    </h3>
    <div v-html='desc'></div>

    <div class="custom-control custom-checkbox text-center mt-3 mb-2">
        <input type="checkbox" v-model='mdl' id="argt" class="custom-control-input"> 
        <label for="argt" class="custom-control-label">
            Приемам изискванията
        </label>
    </div>
</div>


</template>

<script>
    export default {

        mounted() {

        },

        props : ['desc'],

        created() {
           
        },

        data() {
            return {
                isReady : false,
                mdl : false,
            }
        },

        methods : {

        },

        watch : {
            mdl(n,o) {
                this.$parent.acceptTerms = n;
            }
        }

    }
</script>
